"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.guid = void 0;
var guid = function () {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
};
exports.guid = guid;
//# sourceMappingURL=guid.js.map